import { h } from 'preact';
import { ArticleCard } from './ArticleCard';
import styles from './ArticleList.module.scss';
export function ArticleList({ articles, loading }) {
    if (loading) {
        return (h("div", { class: styles.articleList },
            h("div", { class: styles.loading }, "Loading articles...")));
    }
    if (articles.length === 0) {
        return (h("div", { class: styles.articleList },
            h("div", { class: styles.emptyState }, "No articles found")));
    }
    return (h("div", { class: styles.articleList }, articles.map((article) => (h(ArticleCard, { key: article.id, article: article })))));
}
